import { render } from "./Materiales.vue?vue&type=template&id=4b7c5e66&scoped=true"
import script from "./Materiales.vue?vue&type=script&lang=js"
export * from "./Materiales.vue?vue&type=script&lang=js"

import "./Materiales.vue?vue&type=style&index=0&id=4b7c5e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7c5e66"]])

export default __exports__